import { isDevelopment, fontFamily } from '../../library/constants';
// import 'jest-canvas-mock';

const canvas = document.createElement("canvas");
// const font = `${labelFontSize}px ${labelFontFamily}`;

const calcTextWidth = (text, font) => { //https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}

export const trAvailable = () => {
  return typeof(window.tr) !== 'undefined';
}

export const translatePhrase = ({ phrase, varStr }) => { // returns DOM object with clickable link for translation
  if(isDevelopment) { return phrase + '_xyc'; }
  return window.tr(phrase, null, {varStr});
}

export const translateLabel = ({ label, description }) => { // return string
  if(isDevelopment) { return label + '_xyc'; }
  return window.trl(label, description);
}


export const translateLabels = () => {

  let objs = [
    {
      label: 'Center Image in Frame'
    },
    {
      label: 'Inconsistency'
    },
    {
      label: 'DNA Tested'
    },
    {
      label: 'Cycle Count'
    },
    {
      label: 'Pending merge'
    },
    {
      label: 'GEDCOM import in progress'
    },
    {
      label: 'Tree conflict'
    },
    {
      label: 'Family'
    },
    {
      label: 'Current Family',
      description: "Existing family members in the tree"
    },
    {
      label: 'Add New Document',
      description: ""
    },
    {
      label: 'Profile Details'
    },
    {
      label: 'Information'
    },
    {
      label: 'Immediate Family'
    },
    {
      label: 'Import'
    },
    {
      label: 'Skip Import'
    },
    {
      label: 'This profile can be seen by focusing on its own tree.'
    },
    {
      label: 'A GEDCOM import is in progress for this profile. You should not add onto this profile until the import is finished.'
    },
    {
      label: 'Descendants'
    },
    {
      label: 'Ancestors'
    },
    {
      label: 'Tree Preferences'
    },
    {
      label: 'or'
    },
    {
      label: 'and'
    },
    {
      label: 'Previous tip'
    },
    {
      label: 'Next tip'
    },
    {
      label: 'Close tip'
    },
    {
      label: 'Ok'
    },
    {
      label: 'ok'
    },
    {
      label: 'is'
    },
    {
      label: 'undo'
    },
    {
      label: 'Reset'
    },
    {
      label: 'Save'
    },
    {
      label: 'PDF'
    },
    {
      label: 'Submit'
    },
    {
      label: 'Please confirm'
    },
    {
      label: 'Resolve Tree Matches'
    },
    {
      label: 'Resolve'
    },
    {
      label: 'Cancel'
    },
    {
      label: 'cancel'
    },
    {
      label: 'Are you sure?'
    },
    {
      label: 'Profile deleted'
    },
    {
      label: 'This profile will be removed from your list.'
    },
    {
      label: 'edit'
    },  {
      label: 'tree',
      description: "view a profile's tree"
    }, {
      label: 'add',
      description: "add a node"
    }, {
      label: 'more',
      description: "delete profile"
    },

/*
      More Menu
*/

    {
      label: 'add family',  /* not in the db */
      labelFontSize: 3.3,
      labelFontFamily: fontFamily,
    }, {
      label: 'remove family',  /* not in the db */
      labelFontSize: 3.3,
      labelFontFamily: fontFamily,
    }, {
      label: 'delete',
      description: "delete profile"
    }, {
      label: 'add to projects',  /* Book */
      labelFontSize: 3.3,
      labelFontFamily: fontFamily,
    }, {
      label: 'curator options',  /* Book */
      labelFontSize: 3.3,
      labelFontFamily: fontFamily,
    }, {
      label: 'add sources',  /* Book */
      labelFontSize: 3.3,
      labelFontFamily: fontFamily,
    }, {
      label: 'Send message'
    }, {
      label: 'Move Profile'
    }, {
      label: 'Resolve Duplicates'
    }, {
      label: 'remove collaborator'
    }, {
      label: 'remove photo'
    }, {
      label: 'add collaborator'
    }, {
      label: 'add photo'
    }, {
      label: 'view profile'
    },


/*

      Move

*/


    {
      label: 'Map These People'
    }, {
      label: 'Map This Person'
    }, {
      label: 'Drag these nodes into their new (or additional) place on the tree.'
    }, {
      label: 'Move these people'
    }, {
      label: 'Move these people to merge duplicates or create a cycle. To move a person, drag the node onto its duplicate or related family member in the tree.'
    }, {
      label: 'A [b_italic:cycle] occurs when the same person appears more than once in your tree (for example, when two sisters marry two brothers).'
    }, {
      label: 'Notification'
    }, {
      label: 'Yes, proceed'
    }, {
      label: 'Cancel'
    }, {
      label: 'This person is the same.'
    }, {
      label: 'husband'
    }, {
      label: 'wife'
    }, {
      label: 'brother'
    }, {
      label: 'sister'
    }, {
      label: 'son'
    }, {
      label: 'daughter'
    },


/*

      Invite

*/


    {
      label: 'Enter email address'
    }, {
      label: 'The input is not valid E-mail.'
    }, {
      label: 'Email can not be empty.'
    }, {
      label: 'Invitation sent'
    },

/*

      Resolve

*/


    {
      label: 'Merging trees can create duplicate entries.  Drag-and-drop the duplicates onto each other.'
    },
    {
      label: 'To remove a set of parents or specify non-biological relationships'
    },
    {
      label: "edit this profile's relationships."
    },
    {
      label: 'Merge Duplicates'
    },
    {
      label: 'parent'
    },
    {
      label: 'New partner'
    },
    {
      label: 'partner'
    },
    {
      label: 'sibling'
    },
    {
      label: 'children'
    },
    {
      label: 'unlink'
    },
    {
      label: 'Select parents'
    },

/*
      About Content
**/

    {
      label: 'Birth'
    }, {
      label: 'Death'
    }, {
      label: 'Occupation'
    }, {
      label: 'About'
    }, {
      label: 'Location'
    }, {
      label: 'Curator'
    }, {
      label: 'Joined'
    }, {
      label: 'Private Profile'
    }, {
      label: 'Profile History'
    }, {
      label: 'Updated by'
    }, {
      label: 'Added by'
    }, {
      label: 'DNA markers'
    }, {
      label: 'Managed by'
    }

/*

  Add family for mobile

 */

    ,{
      label: 'person'
    }

    ,{
      label: 'father'
    }

    ,{
      label: 'Parents'
    },

    {
      label: 'mother'
    },

    {
      label: 'Add father'
    },

    {
      label: 'Add mother'
    },

    {
      label: 'Add partner'
    },

    {
      label: 'Partner'
    },

    {
      label: 'Partners and Children'
    },

    {
      label: 'Add husband'
    },

    {
      label: 'Add wife'
    },

    {
      label: 'Siblings'
    },

    {
      label: 'Add sister'
    },
    {
      label: 'Add brother'
    },

    {
      label: 'Children'
    },

    {
      label: 'Add son'
    },

    {
      label: 'Add daughter'
    },

    {
      label: 'Add person'
    },

    {
      label: 'Add spouse'
    }

  ];

  objs = objs.map((obj)=>{
    const labelFontSize = 3.3;
    const labelFontFamily = fontFamily;
    return {...obj, ...{ labelFontSize, labelFontFamily}}
  })

  objs.push({
      label: 'invite',
      description: "invite a profile",
      labelFontSize: 3,
      labelFontFamily: fontFamily,
  });

  const labelsObjsArray = objs.map( (obj) => {

    const label = obj.label;
    const description = obj.description;
    const labelFontFamily = obj.labelFontFamily;
    const labelFontSize = obj.labelFontSize;
    const font = `${labelFontSize}px ${labelFontFamily}`
    const width = calcTextWidth(label, font);

    const translatedLabel = translateLabel({label, description});

    const translatedWidth = calcTextWidth(translatedLabel, font);

    return { labelFontFamily, labelFontSize, label, description, width, translatedLabel, translatedWidth};

  });

  const labelsObjs = {};
  labelsObjsArray.forEach( (obj) => {
    labelsObjs[obj.label] = obj;
    delete labelsObjs[obj.label].label;
  });


  return labelsObjs;

};

